import { PublisherModel } from "../../desktop/models/publisher";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { prop } from "../../decorators/property";
import { AppSettings } from "../../app-settings";

@backboneModelProperties({
    relations: [{
        key: "Publisher",
        relatedModel: PublisherModel,
        type: Backbone.One,
    }],
    urlRoot: `${AppSettings.ApiUrlPrefix}/full-text-sources`
})

export class CitationLinkModel extends Backbone.AssociatedModel {
    @prop() public Publisher: PublisherModel;
    @prop() public Description: string;
    @prop() public Url: string;
    @prop() public NoLinks: boolean;
    @prop() public AllAreHidden: boolean;
    @prop() public DisplayLink: boolean;
    @prop() public SiteId: number;
    @prop() public IsJustisOneUrl = false;
    @prop() public IsLegislationUrl = false;
    @prop() public IsJudgmentUrl = false;
    @prop() public IsReportUrl = false;
    @prop() public Source: string;

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/citation-link-model.ts